import React from "react";
import styled from "styled-components";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.bealyo.bealyoapp";

//const APP_STORE_URL = "PASTE_YOUR_APP_STORE_URL_HERE";
const APP_STORE_URL = "https://apps.apple.com/app/id6773874077";

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 0px 20px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #e5e7eb;
  background:
    radial-gradient(circle at top, rgba(56, 189, 248, 0.25), transparent 60%),
    radial-gradient(
      circle at bottom,
      rgba(236, 72, 153, 0.18),
      transparent 55%
    ),
    #020617;
  background-attachment: fixed;
`;

const LogoWrap = styled.div`
  margin-bottom: 22px;

  img {
    height: 58px;
    width: auto;
    display: block;
    object-fit: contain;
  }

  @media (max-width: 600px) {
    img {
      height: 48px;
    }
  }
`;

const SectionTitle = styled.section`
  max-width: 760px;
  text-align: center;
  margin: 28px auto 22px;

  h2 {
    font-size: 34px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  p {
    color: rgba(226, 232, 240, 0.78);
    font-size: 17px;
    line-height: 1.6;
  }
`;

const FeatureGrid = styled.section`
  max-width: 1100px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin: 0 auto 44px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureBox = styled.div`
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.95),
    rgba(15, 23, 42, 0.74)
  );
  border: 1px solid rgba(148, 163, 184, 0.36);
  border-radius: 22px;
  padding: 22px;
  min-height: 190px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);

  div {
    font-size: 30px;
    margin-bottom: 12px;
  }

  h3 {
    font-size: 19px;
    margin-bottom: 8px;
  }

  p {
    color: rgba(226, 232, 240, 0.78);
    line-height: 1.55;
    font-size: 14px;
  }
`;

const Hero = styled.section`
  max-width: 1100px;
  width: 100%;
  margin: 0px auto 50px;
  display: flex;
  align-items: center;
  gap: 48px;
  flex-wrap: wrap;
`;

const HeroLeft = styled.div`
  flex: 1 1 320px;
`;

const HeroRight = styled.div`
  flex: 1 1 260px;
  display: flex;
  justify-content: center;
`;

const Pill = styled.div`
  display: inline-block;
  padding: 7px 16px;
  border-radius: 999px;

  background: rgba(0, 125, 244, 0.12);
  border: 1px solid rgba(0, 125, 244, 0.45);

  color: #007df4;

  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 18px;
`;

const FinalCTA = styled.section`
  max-width: 760px;
  width: 100%;
  text-align: center;
  margin: 20px auto 42px;
  padding: 34px 28px;
  border-radius: 28px;
  background:
    radial-gradient(
      circle at top left,
      rgba(249, 115, 22, 0.28),
      transparent 50%
    ),
    radial-gradient(
      circle at bottom right,
      rgba(236, 72, 153, 0.28),
      transparent 50%
    ),
    rgba(15, 23, 42, 0.92);
  border: 1px solid rgba(248, 113, 113, 0.35);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.55);

  h2 {
    font-size: 26px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  p {
    color: rgba(226, 232, 240, 0.86);
    font-size: 17px;
    line-height: 1.65;
    margin-bottom: 24px;
  }
`;

const Title = styled.h1`
  font-size: 56px;
  font-weight: 800;
  margin-bottom: 18px;
  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.7);

  @media (max-width: 600px) {
    font-size: 40px;
  }
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: rgba(226, 232, 240, 0.85);
  max-width: 620px;
  margin: 0 0 28px;
  line-height: 1.6;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const StepsCard = styled.div`
  background:
    radial-gradient(
      circle at top left,
      rgba(56, 189, 248, 0.22),
      transparent 60%
    ),
    radial-gradient(
      circle at bottom right,
      rgba(168, 85, 247, 0.25),
      transparent 55%
    ),
    rgba(15, 23, 42, 0.96);
  backdrop-filter: blur(18px);
  border-radius: 24px;
  padding: 26px 26px 22px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.75);
  max-width: 420px;
`;

const DownloadTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 16px;
  text-align: left;
`;

const Steps = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0 0 22px;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 6px 0;
    font-size: 15px;
    color: rgba(226, 232, 240, 0.92);
  }
`;

const StepNumber = styled.span`
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
`;

const DownloadButton = styled.a`
  width: 190px;
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition:
    transform 0.15s ease,
    opacity 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    opacity: 0.92;
    text-decoration: none;
  }

  img {
    width: 190px;
    height: auto;
    display: block;
  }

  @media (max-width: 420px) {
    width: 180px;

    img {
      width: 180px;
    }
  }
`;
const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
`;

const SmallNote = styled.p`
  margin-top: 12px;
  font-size: 13px;
  color: rgba(148, 163, 184, 0.88);
  line-height: 1.5;
`;

/* ---- PHONE + CAROUSEL ---- */

const PhoneCarousel = styled.div`
  position: relative;
  width: 260px;
  height: 520px;

  @media (max-width: 600px) {
    width: 240px;
    height: 480px;
  }
`;

const PhoneMock = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 38px;
  padding: 14px;
  background: linear-gradient(145deg, #111827, #020617);
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.9);
`;

const PhoneScreen = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 28px;
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #e5e7eb;
  font-size: 13px;
  background: ${(props) => {
    if (props.variant === "gps") {
      return "radial-gradient(circle at top, #3b82f6, #0f172a 45%, #020617 100%)";
    }
    if (props.variant === "community") {
      return "radial-gradient(circle at top, #a855f7, #0f172a 45%, #020617 100%)";
    }
    return "radial-gradient(circle at top, #22c55e, #0f172a 45%, #020617 100%)";
  }};
`;

const PhoneHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`;

const PhoneChip = styled.div`
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.8);
  font-size: 11px;
`;

const PhoneCard = styled.div`
  background: rgba(15, 23, 42, 0.9);
  border-radius: 16px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px solid rgba(148, 163, 184, 0.35);
`;

const Feedback = styled.footer`
  max-width: 1100px;
  width: 100%;
  margin: 36px auto 0;
  padding: 26px 28px 20px;
  border-top: 1px solid rgba(148, 163, 184, 0.24);
  color: rgba(226, 232, 240, 0.82);
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 28px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 22px;
    text-align: center;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h4 {
    font-size: 13px;
    margin: 0 0 4px;
    color: #ffffff;
    font-weight: 900;
  }

  a,
  button {
    border: none;
    background: transparent;
    padding: 0;
    color: rgba(226, 232, 240, 0.68);
    text-decoration: none;
    font-size: 14px;
    line-height: 1.4;
    text-align: left;
    cursor: pointer;
    font-family: inherit;
  }

  a:hover,
  button:hover {
    color: #007df4;
  }

  @media (max-width: 760px) {
    align-items: center;

    a,
    button {
      text-align: center;
    }
  }
`;

const PageHero = styled.div`
  max-width: 820px;
  margin: 0px 0 40px;

  h1 {
    font-size: 42px;
    font-weight: 900;
    margin: 0 0 14px;
    line-height: 1.15;
    color: #ffffff;
    text-shadow: 0 8px 24px rgba(0, 0, 0, 0.55);
  }

  p {
    margin: 0;
    font-size: 18px;
    line-height: 1.65;
    color: rgba(226, 232, 240, 0.86);
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 32px;
    }

    p {
      font-size: 16px;
    }
  }
`;

const FooterBottom = styled.div`
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
  font-size: 12px;
  color: rgba(148, 163, 184, 0.72);

  @media (max-width: 760px) {
    text-align: center;
  }
`;

/* Carousel controls */

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: rgba(15, 23, 42, 0.95);
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e5e7eb;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.7);
  font-size: 16px;
  padding: 0;

  &:hover {
    background: rgba(30, 64, 175, 0.98);
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;

const NavPrev = styled(NavButton)`
  left: -18px;

  @media (max-width: 600px) {
    left: -6px;
  }
`;

const NavNext = styled(NavButton)`
  right: -18px;

  @media (max-width: 600px) {
    right: -6px;
  }
`;

const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 14px;
`;

const StatsRow = styled.section`
  max-width: 1100px;
  width: 100%;
  margin: -20px auto 36px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const StatCard = styled.div`
  background: rgba(15, 23, 42, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 18px;
  padding: 16px;
  backdrop-filter: blur(14px);

  strong {
    display: block;
    font-size: 18px;
    margin-bottom: 5px;
  }

  span {
    color: rgba(226, 232, 240, 0.78);
    font-size: 13px;
    line-height: 1.45;
  }
`;

const Dot = styled.button`
  width: ${(props) => (props.active ? "14px" : "8px")};
  height: 8px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  background: ${(props) =>
    props.active ? "#007df4" : "rgba(148, 163, 184, 0.7)"};
  opacity: ${(props) => (props.active ? 1 : 0.6)};
  padding: 0;
`;

/* ---- REST OF THE PAGE ---- */

const WhyRow = styled.section`
  max-width: 1100px;
  width: 100%;
  margin: 0 auto 40px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const WhyCard = styled.div`
  background: rgba(15, 23, 42, 0.95);
  border-radius: 18px;
  padding: 18px 20px;
  border: 1px solid rgba(148, 163, 184, 0.45);

  h3 {
    font-size: 17px;
    margin-bottom: 6px;
  }

  p {
    font-size: 14px;
    color: rgba(209, 213, 219, 0.9);
    line-height: 1.55;
  }
`;

const Features = styled.section`
  max-width: 900px;
  width: 100%;
  margin: 10px auto 36px;
  text-align: center;

  h3 {
    font-size: 22px;
    margin-bottom: 14px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    margin: 6px 0;
    font-size: 16px;
    color: rgba(226, 232, 240, 0.9);
  }
`;

const FooterSection = styled.footer`
  max-width: 1100px;
  width: 100%;
  margin: 20px auto 0;
`;

const FooterCard = styled.div`
  padding: 24px 28px;
  border-radius: 30px;
  text-align: center;
  background:
    radial-gradient(
      circle at top left,
      rgba(56, 189, 248, 0.18),
      transparent 55%
    ),
    radial-gradient(
      circle at bottom right,
      rgba(249, 115, 22, 0.2),
      transparent 55%
    ),
    rgba(15, 23, 42, 0.94);
  border: 1px solid rgba(148, 163, 184, 0.34);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.45);
`;

const FooterBrand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  img {
    height: 34px;
    width: auto;
    display: block;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    color: rgba(226, 232, 240, 0.68);
    line-height: 1.5;
    margin: 0;
  }

  @media (max-width: 760px) {
    align-items: center;
    text-align: center;
  }
`;

const FooterTitle = styled.h2`
  font-size: 22px;
  font-weight: 900;
  margin-bottom: 12px;

  @media (max-width: 600px) {
    font-size: 26px;
  }
`;

const FooterText = styled.p`
  max-width: 680px;
  margin: 0 auto 24px;
  color: rgba(226, 232, 240, 0.82);
  font-size: 16px;
  line-height: 1.65;
`;

const FooterContact = styled.div`
  margin: 0 auto 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: rgba(226, 232, 240, 0.74);

  a {
    color: #ffffff;
    font-weight: 900;
    font-size: 17px;
    text-decoration: none;
  }

  a:hover {
    color: #007df4;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 24px;

  a {
    padding: 8px 14px;
    min-width: 90px;
    font-size: 14px;
    border-radius: 999px;
    color: #e5e7eb;
    text-decoration: none;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(148, 163, 184, 0.28);
    font-weight: 800;
  }

  a:hover {
    background: rgba(249, 115, 22, 0.18);
    border-color: rgba(249, 115, 22, 0.45);
  }
`;

const CommunityGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 22px;
  margin-top: 40px;
  margin-bottom: 25px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 26px;
  }
`;

const CommunityCard = styled.div`
  overflow: hidden;
  border-radius: 24px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.22);
`;

const CommunityImage = styled.img`
  width: 100%;
  height: 170px;
  object-fit: cover;
  display: block;

  @media (max-width: 600px) {
    height: 150px;
  }
`;

const CommunityContent = styled.div`
  padding: 18px;

  strong {
    display: none;
  }

  h3 {
    margin: 0 0 8px;
    font-size: 20px;
    color: #ffffff;
  }

  p {
    margin: 0;
    color: rgba(226, 232, 240, 0.78);
    line-height: 1.5;
    font-size: 14px;
  }
`;

const BestHero = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(300px, 0.9fr);
  gap: 46px;
  align-items: center;
  margin-bottom: 54px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const BestHeroCopy = styled.div`
  h1 {
    max-width: 720px;
    margin: 0 0 18px;
    color: #ffffff;
    font-size: 48px;
    line-height: 1.08;
    font-weight: 900;
    text-shadow: 0 8px 24px rgba(0, 0, 0, 0.55);
  }

  p {
    max-width: 700px;
    margin: 0;
    color: rgba(226, 232, 240, 0.84);
    font-size: 18px;
    line-height: 1.7;
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 35px;
    }

    p {
      font-size: 16px;
    }
  }
`;

const BestHeroVisual = styled.div`
  min-height: 390px;
  border-radius: 30px;
  overflow: hidden;
  position: relative;

  background:
    linear-gradient(
      180deg,
      rgba(2, 6, 23, 0.05) 25%,
      rgba(2, 6, 23, 0.95) 100%
    ),
    url("/earlyaccess/beyourbest1.png") center / cover no-repeat;

  border: 1px solid rgba(148, 163, 184, 0.3);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.55);

  @media (max-width: 900px) {
    min-height: 330px;
  }
`;

const BestVisualText = styled.div`
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 24px;

  strong {
    display: block;
    margin-bottom: 7px;
    color: #ffffff;
    font-size: 22px;
  }

  span {
    color: rgba(226, 232, 240, 0.78);
    font-size: 14px;
    line-height: 1.5;
  }
`;

const BestActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 28px;
`;

const PrimaryAction = styled.button`
  min-height: 48px;
  padding: 0 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  border: none;
  cursor: pointer;
  font-family: inherit;

  background: #007df4;
  color: #ffffff;
  font-weight: 900;

  transition:
    transform 0.18s ease,
    background 0.18s ease;

  &:hover {
    transform: translateY(-2px);
    background: #168cff;
  }
`;

const SecondaryAction = styled.button`
  min-height: 48px;
  padding: 0 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  color: #e5e7eb;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(148, 163, 184, 0.32);

  font-weight: 900;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.11);
  }
`;

const BestJourney = styled.section`
  width: 100%;
  margin: 48px auto 52px;
  padding: 30px;
  border-radius: 28px;

  background:
    radial-gradient(
      circle at top left,
      rgba(0, 125, 244, 0.2),
      transparent 42%
    ),
    radial-gradient(
      circle at bottom right,
      rgba(168, 85, 247, 0.2),
      transparent 44%
    ),
    rgba(15, 23, 42, 0.86);

  border: 1px solid rgba(148, 163, 184, 0.26);

  h2 {
    margin: 0 0 12px;
    color: #ffffff;
    font-size: 28px;
  }

  > p {
    max-width: 760px;
    margin: 0;
    color: rgba(226, 232, 240, 0.8);
    line-height: 1.65;
    font-size: 16px;
  }

  @media (max-width: 600px) {
    padding: 22px;
  }
`;

const JourneySteps = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-top: 26px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const JourneyCard = styled.div`
  padding: 18px;
  border-radius: 18px;
  background: rgba(2, 6, 23, 0.48);
  border: 1px solid rgba(148, 163, 184, 0.2);

  span {
    display: block;
    margin-bottom: 10px;
    font-size: 26px;
  }

  h3 {
    margin: 0 0 7px;
    color: #ffffff;
    font-size: 17px;
  }

  p {
    margin: 0;
    color: rgba(226, 232, 240, 0.72);
    font-size: 13px;
    line-height: 1.5;
  }
`;

/* ---- PHONE SCREEN DATA ---- */

const phoneScreensOld = [
  {
    id: "daily",
    variant: "daily",
    header: "Today • 5.2 km",
    chip: "Streak x4 🔥",
    footer: "Track your activities, habits and wins in one place.",
    body: () => (
      <div style={{ marginTop: 12 }}>
        <PhoneCard>
          <strong>Morning Run</strong>
          <div>Park • 32 min • 4.1 km</div>
        </PhoneCard>
        <PhoneCard>
          <strong>Cold Shower Legend</strong>
          <div>Task completed • +15 XP</div>
        </PhoneCard>
        <PhoneCard>
          <strong>Hydration Hero</strong>
          <div>8/8 cups logged</div>
        </PhoneCard>
      </div>
    ),
  },
  {
    id: "gps",
    variant: "gps",
    header: "Saturday Run • 7.8 km",
    chip: "Route complete ✅",
    footer: "See every km, pace and route with live GPS tracking.",
    body: () => (
      <div style={{ marginTop: 12 }}>
        <PhoneCard style={{ marginBottom: 10 }}>
          <strong>City Loop Route</strong>
          <div>7.8 km • 5:42 /km • 44 min</div>
        </PhoneCard>
        <PhoneCard>
          <div style={{ fontSize: 11, opacity: 0.9 }}>
            Split times, pace zones and elevation — all in one clean view.
          </div>
        </PhoneCard>
      </div>
    ),
  },
  {
    id: "community",
    variant: "community",
    header: "Circle • Morning Legends",
    chip: "8 friends active now",
    footer: "Stay accountable with circles, cheers and shared wins.",
    body: () => (
      <div style={{ marginTop: 12 }}>
        <PhoneCard>
          <strong>Noa just crushed “5K & Proud”</strong>
          <div>🔥🔥🔥 • 17 cheers</div>
        </PhoneCard>
        <PhoneCard>
          <strong>You</strong>
          <div>Cold Shower Legend • Day 4 / 7</div>
        </PhoneCard>
        <PhoneCard>
          <div>“Let’s hit 10k steps together today 💪”</div>
        </PhoneCard>
      </div>
    ),
  },
];

const InfoPage = styled.section`
  max-width: 1100px;
  width: 100%;
  margin: 0px auto 60px;
`;

const PageBadge = styled.div`
  display: inline-block;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(0, 125, 244, 0.16);
  color: #007df4;
  border: 1px solid rgba(0, 125, 244, 0.35);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 18px;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 22px;
  margin-top: 40px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const InfoCard = styled.div`
  padding: 28px;
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.96),
    rgba(15, 23, 42, 0.82)
  );
  border: 1px solid rgba(148, 163, 184, 0.28);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);

  strong {
    display: block;
    font-size: 42px;
    margin-bottom: 18px;
  }

  h3 {
    margin: 0 0 10px;
    font-size: 24px;
    color: white;
  }

  p {
    margin: 0;
    color: rgba(226, 232, 240, 0.8);
    line-height: 1.7;
    font-size: 15px;
  }
`;

const phoneScreens = [
  {
    id: "daily",
    variant: "daily",
    header: "Daily wins & streaks",
    footer: "Track your activities, habits and wins in one place.",
    image: "/earlyaccess/home1dark@2x.png",
  },
  {
    id: "gps",
    variant: "gps",
    header: "GPS running & walking",
    footer: "See every km, pace and route with live GPS tracking.",
    image: "/earlyaccess/home2dark@2x.png",
  },
  {
    id: "leaderboards",
    variant: "leaderboards",
    header: "Leaderboards & rankings",
    footer: "Compete with friends and climb the leaderboard together.",
    image: "/earlyaccess/homeleader@2x.png",
  },
  {
    id: "community",
    variant: "community",
    header: "Circles & community",
    footer: "Stay accountable with circles, cheers and shared wins.",
    image: "/earlyaccess/home4dark@2x.png",
  },
];

const PhoneImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 28px;
  object-fit: cover;
  display: block;
`;

const SiteHeader = styled.header`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto 20px;
  padding-top: 20px;
  position: sticky;
  top: 0;
  z-index: 20;

  @media (max-width: 760px) {
    margin-bottom: 14px;
    padding-top: 10px;
  }
`;

const HeaderInner = styled.div`
  height: 68px;
  padding: 0 18px;
  border-radius: 22px;
  background: rgba(15, 23, 42, 0.86);
  border: 1px solid rgba(148, 163, 184, 0.28);
  backdrop-filter: blur(18px);
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 760px) {
    height: 62px;
    padding: 0 14px;
    border-radius: ${(props) => (props.menuOpen ? "18px 18px 0 0" : "18px")};
  }
`;

const HeaderLogo = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;

  img {
    height: 42px;
    display: block;
  }
`;

const DesktopNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 760px) {
    display: none;
  }
`;

const NavLink = styled.button`
  border: none;
  cursor: pointer;
  padding: 10px 16px;
  border-radius: 999px;
  color: #e5e7eb;

  background: ${(props) =>
    props.active ? "rgba(0,125,244,0.18)" : "transparent"};

  border: 1px solid
    ${(props) => (props.active ? "rgba(0,125,244,0.45)" : "transparent")};

  font-weight: 700;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 125, 244, 0.12);
    color: white;
  }
`;

const MenuButton = styled.button`
  display: none;
  border: none;
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  font-size: 24px;
  cursor: pointer;

  @media (max-width: 760px) {
    display: block;
  }
`;

const MobileMenu = styled.div`
  margin-top: 0;
  padding: 8px;
  border-radius: 0 0 16px 16px;
  background: rgba(15, 23, 42, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.26);
  border-top: none;
  display: grid;
  gap: 5px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.42);
`;

const MobileNavLink = styled.button`
  width: 100%;
  text-align: left;
  border: none;
  cursor: pointer;
  padding: 11px 13px;
  border-radius: 12px;
  color: #e5e7eb;

  background: ${(props) =>
    props.active ? "rgba(0, 125, 244, 0.18)" : "transparent"};

  border: 1px solid
    ${(props) => (props.active ? "rgba(0, 125, 244, 0.36)" : "transparent")};

  font-weight: 800;
  font-size: 14px;
  font-family: inherit;

  transition:
    background 0.18s ease,
    border-color 0.18s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

const StepsGrid = styled.div`
  max-width: 1100px;
  width: 100%;
  margin: 34px auto 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const SectionHeader = styled.div`
  margin-bottom: 28px;

  h2 {
    margin: 0;
    margin-top: 10px;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.2;
    color: #fff;
  }

  p {
    margin: 12px 0 0;
    font-size: 18px;
    line-height: 1.6;
    color: rgba(226, 232, 240, 0.82);
    max-width: 720px;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 28px;
    }

    p {
      font-size: 16px;
    }
  }
`;

const StepCard = styled.div`
  padding: 20px;
  border-radius: 20px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.22);

  h3 {
    font-size: 18px;
    margin: 12px 0 8px;
    color: #ffffff;
  }

  p {
    margin: 0;
    color: rgba(226, 232, 240, 0.76);
    font-size: 14px;
    line-height: 1.5;
  }
`;

const StepCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(249, 115, 22, 0.16);
  border: 1px solid rgba(249, 115, 22, 0.38);
  color: #fed7aa;
  font-weight: 900;
  font-size: 14px;
`;

const ProductHome = () => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [activePage, setActivePage] = React.useState("home");
  const [menuOpen, setMenuOpen] = React.useState(false);

  const active = phoneScreens[activeIndex];

  const pages = [
    { id: "home", label: "Home" },
    { id: "best", label: "Be Your Best" },
    { id: "community", label: "Start a Community" },
    { id: "contact", label: "Contact" },
  ];

  const goToPage = (pageId) => {
    setActivePage(pageId);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goPrev = () => {
    setActiveIndex((prev) => (prev === 0 ? phoneScreens.length - 1 : prev - 1));
  };

  const goNext = () => {
    setActiveIndex((prev) => (prev === phoneScreens.length - 1 ? 0 : prev + 1));
  };

  return (
    <PageContainer>
      <SiteHeader>
        <HeaderInner menuOpen={menuOpen}>
          <HeaderLogo onClick={() => goToPage("home")}>
            <img src="/logo.png" alt="Bealyo" />
          </HeaderLogo>

          <DesktopNav>
            {pages.map((page) => (
              <NavLink
                key={page.id}
                active={activePage === page.id}
                onClick={() => goToPage(page.id)}
              >
                {page.label}
              </NavLink>
            ))}
          </DesktopNav>

          <MenuButton onClick={() => setMenuOpen((prev) => !prev)}>
            {menuOpen ? "×" : "☰"}
          </MenuButton>
        </HeaderInner>

        {menuOpen && (
          <MobileMenu>
            {pages.map((page) => (
              <MobileNavLink
                key={page.id}
                active={activePage === page.id}
                onClick={() => goToPage(page.id)}
              >
                {page.label}
              </MobileNavLink>
            ))}
          </MobileMenu>
        )}
      </SiteHeader>
      {activePage === "home" && (
        <>
          <Hero>
            <HeroLeft>
              <PageHero>
                <PageBadge>Now Available on iPhone & Android</PageBadge>

                <h1>Be the Best Version of Yourself</h1>

                <p>
                  Bealyo helps you turn good intentions into real daily
                  progress. Build better habits, complete meaningful challenges,
                  stay active, track your health, and grow with a positive
                  community that cheers you forward.
                </p>

                <p style={{ marginTop: 20 }}>
                  Start small. Stay consistent. Become the person you know you
                  can be.
                </p>
              </PageHero>

              <StepsCard>
                <DownloadTitle>Start Your Journey Today</DownloadTitle>

                <Steps>
                  <li>
                    <StepNumber>1</StepNumber>Download Bealyo on iPhone or
                    Android
                  </li>
                  <li>
                    <StepNumber>2</StepNumber>Create your free account
                  </li>
                  <li>
                    <StepNumber>3</StepNumber>Choose goals, challenges, or
                    habits that matter to you
                  </li>
                  <li>
                    <StepNumber>4</StepNumber>Take small daily steps toward your
                    best self
                  </li>
                </Steps>

                <ButtonRow>
                  <DownloadButton
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/store-badges/app-store-badge.svg"
                      alt="Download on the App Store"
                    />
                  </DownloadButton>

                  <DownloadButton
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/store-badges/google-play-badge.png"
                      alt="Get it on Google Play"
                    />
                  </DownloadButton>
                </ButtonRow>

                <SmallNote>
                  Bealyo is live now. Your next step starts today.
                </SmallNote>
              </StepsCard>
            </HeroLeft>

            <HeroRight>
              <div>
                <PhoneCarousel>
                  <PhoneMock>
                    <PhoneImage src={active.image} alt={active.header} />
                    {/**
                <PhoneScreen variant={active.variant}>
                  <div>
                    <PhoneHeader>
                      <span>{active.header}</span>
                      <PhoneChip>{active.chip}</PhoneChip>
                    </PhoneHeader>
                    {active.body()}
                  </div>
                  <PhoneFooter>{active.footer}</PhoneFooter>
                </PhoneScreen>
                */}
                  </PhoneMock>

                  <NavPrev onClick={goPrev} aria-label="Previous screen">
                    ‹
                  </NavPrev>
                  <NavNext onClick={goNext} aria-label="Next screen">
                    ›
                  </NavNext>
                </PhoneCarousel>

                <Dots>
                  {phoneScreens.map((screen, i) => (
                    <Dot
                      key={screen.id}
                      active={i === activeIndex}
                      onClick={() => setActiveIndex(i)}
                      aria-label={`Show ${screen.id} preview`}
                    />
                  ))}
                </Dots>
              </div>
            </HeroRight>
          </Hero>

          <StatsRow>
            <StatCard>
              <strong>Goals</strong>
              <span>Create challenges, habits, and routines</span>
            </StatCard>
            <StatCard>
              <strong>GPS</strong>
              <span>Track walks, runs, distance, and pace</span>
            </StatCard>
            <StatCard>
              <strong>Nutrition</strong>
              <span>Log meals, calories, and daily health</span>
            </StatCard>
            <StatCard>
              <strong>Community</strong>
              <span>Join circles and grow with others</span>
            </StatCard>
          </StatsRow>

          <SectionTitle>
            <h2>One App for Your Personal Growth</h2>
            <p>
              Bealyo brings goals, health, activity tracking, routines, and
              community into one experience designed to help you keep moving.
            </p>
          </SectionTitle>

          <FeatureGrid>
            {[
              [
                "🎯",
                "Goals & Challenges",
                "Create personal goals, join challenges, and follow clear daily actions.",
              ],
              [
                "🏃",
                "GPS Activity Tracking",
                "Track walks and runs with distance, pace, time, and route history.",
              ],
              [
                "🥗",
                "Nutrition & Meals",
                "Manage meals, calories, hydration, and healthier daily choices.",
              ],
              [
                "✅",
                "Daily Tasks",
                "Break big goals into small actions you can complete every day.",
              ],
              [
                "🔥",
                "Streaks & Badges",
                "Stay motivated with progress, streaks, XP, and achievements.",
              ],
              [
                "👥",
                "Circles",
                "Join positive groups where people support, cheer, and grow together.",
              ],
            ].map(([icon, title, text]) => (
              <FeatureBox key={title}>
                <div>{icon}</div>
                <h3>{title}</h3>
                <p>{text}</p>
              </FeatureBox>
            ))}
          </FeatureGrid>

          <WhyRow>
            <WhyCard>
              <h3>Build Momentum</h3>
              <p>
                Turn goals into daily action through habits, challenges,
                routines, and small wins that keep you moving forward.
              </p>
            </WhyCard>

            <WhyCard>
              <h3>See Your Progress</h3>
              <p>
                Track workouts, runs, walks, nutrition, daily tasks, and
                personal achievements so every effort counts.
              </p>
            </WhyCard>

            <WhyCard>
              <h3>Grow Together</h3>
              <p>
                Join a positive community where people encourage each other,
                celebrate progress, and stay accountable.
              </p>
            </WhyCard>
          </WhyRow>

          <FinalCTA>
            <h2>Your Future Self Will Thank You</h2>
            <p>
              Don’t wait for the perfect Monday. Start with one small action
              today. Bealyo helps you build the habits, routines, and mindset
              that move you closer to the person you want to become.
            </p>

            <ButtonRow>
              <DownloadButton
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/app-store-badge.svg"
                  alt="Download on the App Store"
                />
              </DownloadButton>

              <DownloadButton
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/google-play-badge.png"
                  alt="Get it on Google Play"
                />
              </DownloadButton>
            </ButtonRow>
          </FinalCTA>
        </>
      )}

      {activePage === "best" && (
        <InfoPage>
          <BestHero>
            <BestHeroCopy>
              <PageBadge>Be Your Best</PageBadge>

              <h1>Your Best Version Is Built One Day at a Time</h1>

              <p>
                Bealyo gives you one place to take action, track your progress,
                build better habits, and keep moving forward. You do not need to
                change everything at once. Start with one meaningful step and
                build from there.
              </p>

              <BestActions>
                <PrimaryAction
                  onClick={() => {
                    document.getElementById("best-download")?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }}
                >
                  Start Your Journey
                </PrimaryAction>

                <SecondaryAction onClick={() => goToPage("community")}>
                  Explore Communities
                </SecondaryAction>
              </BestActions>
            </BestHeroCopy>

            <BestHeroVisual>
              <BestVisualText>
                <strong>Progress you can actually see</strong>

                <span>
                  Track your activity, distance, habits, health, streaks, and
                  daily wins in one personal journey.
                </span>
              </BestVisualText>
            </BestHeroVisual>
          </BestHero>

          <SectionTitle>
            <h2>Everything You Need to Keep Moving Forward</h2>

            <p>
              Choose what matters to you today. Bealyo helps you turn it into
              clear action, visible progress, and lasting momentum.
            </p>
          </SectionTitle>

          <InfoGrid>
            <InfoCard>
              <strong>🎯</strong>
              <h3>Choose Your Direction</h3>
              <p>
                Create meaningful activities, habits, challenges, and routines
                around fitness, health, mindset, nutrition, or personal growth.
              </p>
            </InfoCard>

            <InfoCard>
              <strong>🏃</strong>
              <h3>Take Real Action</h3>
              <p>
                Track walks, runs, workouts, daily tasks, check-ins, meals, and
                other actions that move you closer to the person you want to be.
              </p>
            </InfoCard>

            <InfoCard>
              <strong>📈</strong>
              <h3>See Your Progress</h3>
              <p>
                Follow your streaks, distance, steps, XP, achievements, and
                consistency so your effort never feels invisible.
              </p>
            </InfoCard>

            <InfoCard>
              <strong>⚡</strong>
              <h3>Reset and Keep Going</h3>
              <p>
                A missed day does not end your journey. Reconnect with what
                matters, take the next step, and build momentum again.
              </p>
            </InfoCard>
          </InfoGrid>

          <BestJourney>
            <PageBadge>Your Journey</PageBadge>

            <h2>Small Actions. Visible Progress. A Stronger You.</h2>

            <p>
              Bealyo is not about being perfect. It is about becoming more
              intentional, more consistent, and more connected to the life you
              want to build.
            </p>

            <JourneySteps>
              <JourneyCard>
                <span>1️⃣</span>
                <h3>Pick One Focus</h3>
                <p>
                  Choose one action, habit, or challenge that matters right now.
                </p>
              </JourneyCard>

              <JourneyCard>
                <span>2️⃣</span>
                <h3>Show Up Today</h3>
                <p>
                  Complete the next small step instead of waiting for perfect.
                </p>
              </JourneyCard>

              <JourneyCard>
                <span>3️⃣</span>
                <h3>Track the Win</h3>
                <p>
                  See your consistency, progress, streaks, and achievements.
                </p>
              </JourneyCard>

              <JourneyCard>
                <span>4️⃣</span>
                <h3>Keep Growing</h3>
                <p>
                  Build on your progress and choose your next meaningful step.
                </p>
              </JourneyCard>
            </JourneySteps>
          </BestJourney>

          <WhyRow>
            <WhyCard>
              <h3>Your Journey Is Personal</h3>
              <p>
                Use Bealyo privately and focus entirely on your own activities,
                habits, health, and progress.
              </p>
            </WhyCard>

            <WhyCard>
              <h3>Support Is There When You Need It</h3>
              <p>
                Join a circle, follow a challenge, or share progress without
                losing control of your individual journey.
              </p>
            </WhyCard>

            <WhyCard>
              <h3>Progress, Not Perfection</h3>
              <p>
                Every meaningful action counts. Bealyo helps you keep moving
                even when the journey is not perfectly smooth.
              </p>
            </WhyCard>
          </WhyRow>

          <FinalCTA id="best-download">
            <PageBadge>Start Today</PageBadge>

            <h2>Be the Best Version of Yourself</h2>

            <p>
              Your next step does not need to be huge. Choose something that
              matters, take action today, and let Bealyo help you build from
              there.
            </p>

            <ButtonRow>
              <DownloadButton
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/app-store-badge.svg"
                  alt="Download on the App Store"
                />
              </DownloadButton>

              <DownloadButton
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/google-play-badge.png"
                  alt="Get it on Google Play"
                />
              </DownloadButton>
            </ButtonRow>

            <SmallNote>
              Free to download • Available for iPhone & Android
            </SmallNote>
          </FinalCTA>
        </InfoPage>
      )}
      {activePage === "community" && (
        <InfoPage>
          <PageHero>
            <PageBadge>Start a Community</PageBadge>

            <h1>Turn Your Community Into a Movement</h1>

            <p>
              Every community has the power to inspire change. Whether you're
              bringing together a family, a gym, a school, a workplace, or a
              group of friends, Bealyo helps you create meaningful challenges,
              celebrate progress, and build lasting habits — together.
            </p>
          </PageHero>

          <CommunityGrid>
            <CommunityCard>
              <CommunityImage
                src="/community/gym-studio.png"
                alt="Gyms & Studios"
              />
              <CommunityContent>
                <h3>Gyms & Studios</h3>
                <p>
                  Keep members engaged with challenges, live leaderboards, and
                  daily motivation that builds a stronger community.
                </p>
              </CommunityContent>
            </CommunityCard>

            <CommunityCard>
              <CommunityImage
                src="/community/trainers-coaches.png"
                alt="Trainers & Coaches"
              />
              <CommunityContent>
                <h3>Trainers & Coaches</h3>
                <p>
                  Support your trainees beyond every session with goals, habits,
                  activities, and progress they can follow every day.
                </p>
              </CommunityContent>
            </CommunityCard>

            <CommunityCard>
              <CommunityImage
                src="/community/families-friends.png"
                alt="Families & Friends"
              />
              <CommunityContent>
                <h3>Families & Friends</h3>
                <p>
                  Create healthy habits together, celebrate every win, and make
                  everyday progress more fun.
                </p>
              </CommunityContent>
            </CommunityCard>

            <CommunityCard>
              <CommunityImage
                src="/community/teams-workplaces.png"
                alt="Teams & Workplaces"
              />
              <CommunityContent>
                <h3>Teams & Workplaces</h3>
                <p>
                  Inspire healthier lifestyles through friendly challenges,
                  teamwork, and shared achievements.
                </p>
              </CommunityContent>
            </CommunityCard>
          </CommunityGrid>

          <PageBadge>Getting Started</PageBadge>
          <SectionHeader>
            <h2>Build Your Community in Minutes</h2>

            <p>
              It only takes a few minutes to build a community people love being
              part of.
            </p>
          </SectionHeader>

          <StepsGrid>
            <StepCard>
              <StepCircle>1</StepCircle>
              <h3>Download Bealyo</h3>
              <p>Download the app and create your free account.</p>
            </StepCard>

            <StepCard>
              <StepCircle>2</StepCircle>
              <h3>Create a Circle</h3>
              <p>Create a public or private circle for your community.</p>
            </StepCard>

            <StepCard>
              <StepCircle>3</StepCircle>
              <h3>Customize Your Circle</h3>
              <p>
                Add challenges, activities, GPS, AI, nutrition, leaderboards,
                and more.
              </p>
            </StepCard>

            <StepCard>
              <StepCircle>4</StepCircle>
              <h3>Grow Together</h3>
              <p>Invite your community and grow stronger together.</p>
            </StepCard>
          </StepsGrid>

          <FinalCTA>
            <PageBadge>Ready?</PageBadge>

            <h2>Your Community Starts Here</h2>

            <ButtonRow>
              <DownloadButton
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/app-store-badge.svg"
                  alt="Download on the App Store"
                />
              </DownloadButton>

              <DownloadButton
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/store-badges/google-play-badge.png"
                  alt="Get it on Google Play"
                />
              </DownloadButton>
            </ButtonRow>

            <SmallNote>
              Free to download • Available for iPhone & Android
            </SmallNote>
          </FinalCTA>
        </InfoPage>
      )}

      {activePage === "contact" && (
        <InfoPage>
          <PageHero>
            <PageBadge>Contact Us</PageBadge>

            <h1>We’d Love to Hear From You</h1>

            <p>
              Have a question, idea, bug report, or want to build a community
              with Bealyo? Send us a message. We’re still early, and your
              feedback really helps shape the product.
            </p>
          </PageHero>

          <InfoGrid>
            <InfoCard>
              <strong>💬</strong>
              <h3>Talk to Us</h3>
              <p>
                Whether you're a user, coach, gym owner, creator, family member,
                or community leader — we’d love to hear what you're building and
                how Bealyo can help.
              </p>
            </InfoCard>

            <InfoCard>
              <strong>📧</strong>
              <h3>Email</h3>
              <p>
                Reach us directly at{" "}
                <a
                  href="mailto:support@bealyo.com"
                  style={{
                    color: "#ffffff",
                    fontWeight: 900,
                    textDecoration: "none",
                  }}
                >
                  support@bealyo.com
                </a>
                . We usually reply as soon as possible.
              </p>
            </InfoCard>

            <InfoCard>
              <strong>👥</strong>
              <h3>Build a Community</h3>
              <p>
                If you run a gym, studio, team, school, workplace, or any group
                that wants to motivate people — Bealyo can help you create
                circles, challenges, activities, and leaderboards.
              </p>
            </InfoCard>

            <InfoCard>
              <strong>🚀</strong>
              <h3>Follow the Journey</h3>
              <p>
                Bealyo is growing step by step. Follow us, share feedback, and
                help us build a better way for people to become the best version
                of themselves.
              </p>
            </InfoCard>
          </InfoGrid>

          <FinalCTA>
            <h2>Let’s Build Better Habits Together</h2>

            <p>
              Small actions become big changes when people support each other.
              If you have an idea, question, or community in mind — reach out.
            </p>

            <FooterLinks>
              <a href="mailto:support@bealyo.com">Email Us</a>

              <a
                href="https://instagram.com/bealyoversion"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>

              <a
                href="https://x.com/bealyoversion"
                target="_blank"
                rel="noreferrer"
              >
                X
              </a>

              <a
                href="https://www.linkedin.com/company/bealyo/"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
            </FooterLinks>
          </FinalCTA>
        </InfoPage>
      )}

      <Feedback>
        <FooterTop>
          <FooterBrand>
            <img src="/logo.png" alt="Bealyo" />
            <p>Be the best version of yourself.</p>
          </FooterBrand>

          <FooterColumn>
            <h4>Explore</h4>

            <button onClick={() => goToPage("home")}>Home</button>
            <button onClick={() => goToPage("best")}>Be Your Best</button>
            <button onClick={() => goToPage("community")}>
              Start a Community
            </button>

            <button onClick={() => goToPage("contact")}>Contact Us</button>
          </FooterColumn>
        </FooterTop>

        <FooterBottom>
          <span>© 2026 Bealyo. Be the best version of yourself.</span>
        </FooterBottom>
      </Feedback>

      {/** 
      <Feedback>
        <FooterTop>
          <FooterBrand>
            <img src="/logo.png" alt="Bealyo" />
            <p>Be the best version of yourself.</p>
          </FooterBrand>

          <FooterColumn>
            <h4>Product</h4>
            <button onClick={() => goToPage("home")}>Download</button>
            <button onClick={() => goToPage("how-to-join")}>How to Join</button>
            <button onClick={() => goToPage("tutorials")}>Tutorials</button>
          </FooterColumn>

          <FooterColumn>
            <h4>Community</h4>
            <button onClick={() => goToPage("leaders")}>For Leaders</button>
            <button onClick={() => goToPage("leaders")}>Circles</button>
            <button onClick={() => goToPage("leaders")}>Leaderboards</button>
          </FooterColumn>

          <FooterColumn>
            <h4>Contact</h4>

            <a href="mailto:support@bealyo.com">support@bealyo.com</a>

            <a
              href="https://instagram.com/bealyoversion"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>

            <a
              href="https://x.com/bealyoversion"
              target="_blank"
              rel="noreferrer"
            >
              X
            </a>

            <a
              href="https://www.linkedin.com/company/bealyo/"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </FooterColumn>
        </FooterTop>

        <FooterBottom>
          <span>© 2026 Bealyo. Small actions. Better together.</span>
        </FooterBottom>
      </Feedback>
      */}
    </PageContainer>
  );
};

export default ProductHome;
